<div class="rfq-multi-hedge-item">
  <div class="icons">
    <img
      src="/assets/delete.png"
      alt="delete"
      title="Delete"
      (click)="delete()"
      [ngClass]="{
        'icon-disabled': rfqRunning || numOfHedges === 1 || isGenericMultiHedge
      }"
    />
  </div>
  <form class="form" [formGroup]="form" autocomplete="off">
    <div class="rfq-setup-content__row">
      @if (hedgeTypes?.length === 1) {
        <input-with-spinner
          type="text"
          formControlName="productType"
          class="amount"
          [readOnly]="true"
        ></input-with-spinner>
      } @else {
        <app-selector
          [passedItems]="hedgeTypes"
          formControlName="productType"
          class="ng-selector-read-only-color-white"
          [readonly]="rfqRunning && numOfHedges > 1"
          (indexSelected)="onElemBlur()"
          (onBlur)="onElemBlur()"
          (onFocus)="onElemFocus()"
        ></app-selector>
      }
    </div>

    <ng-container>
      <div class="rfq-setup-content__row" style="position: relative">
        <input-with-spinner
          type="text"
          formControlName="amount"
          [inputValidator]="['numericShorthand', 'positiveNumber']"
          class="amount"
          [ngClass]="{
            'amount--disabled': isGenericMultiHedge && hedge === 'Forward Hedge'
          }"
          [inert]="isGenericMultiHedge && hedge === 'Forward Hedge'"
          (change)="amountChange()"
          (onBlur)="onElemBlur()"
          (onFocus)="onElemFocus()"
        ></input-with-spinner>
        <span class="ccy"> {{ currencyPair?.base || '???' }} </span>
      </div>

      @if (!isGenericMultiHedge) {
        <div class="rfq-setup-content__row">
          {{ counterparty }}
        </div>
        <div class="rfq-setup-content__row">
          <app-selector
            [passedItems]="['Buy', 'Sell']"
            formControlName="offerDirection"
            class="ng-selector-read-only-color-white"
            (indexSelected)="onElemBlur()"
            (onBlur)="onElemBlur()"
            (onFocus)="onElemFocus()"
          ></app-selector>
        </div>

        <div class="rfq-setup-content__row">
          <input-with-spinner
            formControlName="bidDirection"
            [readOnly]="true"
            (onBlur)="onElemBlur()"
            (onFocus)="onElemFocus()"
          ></input-with-spinner>
        </div>

        <div class="rfq-setup-content__row">
          <input-with-spinner
            type="number"
            formControlName="rate"
            [inputValidator]="['positiveNumber']"
            class="rate {{ hedgeMode }}"
            (keyup)="rateChangeKBEvent($event)"
            (onBlur)="onElemBlur()"
            (onFocus)="onElemFocus()"
          ></input-with-spinner>
        </div>

        <div>
          <date-with-spinner-info
            *ngIf="type === 'NDF'"
            formControlName="expirationDate"
            [inputValidatorKey]="['dateShorthand']"
            class="expiration-date"
            (change)="dateFieldChange('expirationDate')"
            [format]="'D MMM YYYY'"
            [readOnly]="false"
            [required]="true"
          >
          </date-with-spinner-info>
          <span *ngIf="type !== 'NDF'">-</span>
        </div>
      }

      @if (showGenericMultiHedgeFields) {
        <div class="rfq-setup-content__row">
          {{ form.controls['direction'].value }}
        </div>

        <div class="rfq-setup-content__row">
          @if (this.index === 0) {
            <app-selector
              [passedItems]="executionsModes"
              formControlName="executionMode"
              [readonly]="rfqTabService.traded"
              class="ng-selector-read-only-color-white"
              (indexSelected)="onElemBlur()"
              (onBlur)="onElemBlur()"
              (onFocus)="onElemFocus()"
            ></app-selector>
          } @else {
            <div class="rfq-setup-content__row__execution-mode-text">
              {{ executionMode }}
            </div>
          }
        </div>

        <div class="rfq-setup-content__row rfq-setup-content__row--spot-ref">
          @if (
            (form.controls['spotRefAsk']?.enabled &&
              form.controls['spotRefBid']?.enabled) ||
            form.controls['spotRefMid']?.enabled
          ) {
            <app-two-way-spot
              class="rfq-setup-content__row__two-way-hedge"
              [ngClass]="{
                'rfq-setup-content__row__two-way-hedge--disabled': index !== 0
              }"
              [indicesToHighlight]="pipsHighlightedIndices"
              [askName]="'spotRefAsk'"
              [bidName]="'spotRefBid'"
              [midName]="'spotRefMid'"
              [twoWayMode]="spotRefSettings.twoWay"
              [contentEditable]="!spotRefSettings.readonly"
              [form]="$any(form)"
              [pending]="spotRefSettings.pending"
              [incrementsScale]="true"
              (onBlur)="onElemBlur()"
            ></app-two-way-spot>
          }
        </div>

        <div class="rfq-setup-content__row rfq-setup-content__row--fwd-ref">
          @if (
            (form.controls['fwdPointAsk']?.enabled &&
              form.controls['fwdPointBid']?.enabled) ||
            form.controls['fwdPointMid']?.enabled
          ) {
            <app-two-way-spot
              class="rfq-setup-content__row__two-way-hedge"
              [indicesToHighlight]="pipsHighlightedIndices"
              [askName]="'fwdPointAsk'"
              [bidName]="'fwdPointBid'"
              [midName]="'fwdPointMid'"
              [form]="$any(form)"
              [twoWayMode]="fwdPointsSettings.twoWay"
              [contentEditable]="!fwdPointsSettings.readonly"
              [pending]="fwdPointsSettings.pending"
              [incrementsScale]="false"
              (onBlur)="onElemBlur()"
            ></app-two-way-spot>
          }
        </div>

        <div class="rfq-setup-content__row rfq-setup-content__row--fwd-ref">
          @if (
            (form.controls['fwdRateAsk']?.enabled &&
              form.controls['fwdRateBid']?.enabled) ||
            form.controls['fwdRateMid']?.enabled
          ) {
            <app-two-way-spot
              class="rfq-setup-content__row__two-way-hedge"
              [indicesToHighlight]="pipsHighlightedIndices"
              [askName]="'fwdRateAsk'"
              [bidName]="'fwdRateBid'"
              [midName]="'fwdRateMid'"
              [form]="$any(form)"
              [twoWayMode]="fwdRateSettings.twoWay"
              [contentEditable]="!fwdRateSettings.readonly"
              [pending]="fwdRateSettings.pending"
              [incrementsScale]="true"
              (onBlur)="onElemBlur()"
            ></app-two-way-spot>
          }
        </div>
      }

      <div>
        <date-with-spinner-info
          formControlName="settlementDate"
          [inputValidatorKey]="['dateShorthand']"
          class="settlement-date"
          (change)="dateFieldChange('settlementDate')"
          [format]="'D MMM YYYY'"
          [readOnly]="settlementDateReadOnly || rfqRunning"
          [required]="true"
          (onCalendarChange)="onCalendarChange('settlementDate')"
        >
        </date-with-spinner-info>
      </div>

      <div class="rfq-setup-content__row" *ngIf="hedgeMode === 'DX'">
        <span>
          <container-element [ngSwitch]="showImpliedSpot">
            <input-with-spinner
              formControlName="impliedSpot"
              [readOnly]="true"
              *ngSwitchCase="true"
              class="implied-spot"
            ></input-with-spinner>
            <span *ngSwitchDefault>-</span>
          </container-element>
        </span>
      </div>

      @if (showGenericMultiHedgeFields) {
        <div class="rfq-setup-content__row"></div>
        <div class="rfq-setup-content__row rfq-setup-content__row--market-rate">
          @if (index === 0 && marketRates) {
            <span class="market-rate-container">
              <div class="market-rate-bid">
                <app-number-highlighter
                  [startAfterDecimal]="true"
                  [value]="marketRates.spotRates.bid"
                  [indicesToHighlight]="pipsHighlightedIndices"
                ></app-number-highlighter>
              </div>

              <span
                *ngIf="
                  marketRates.spotRates.bid != null &&
                  marketRates.spotRates.ask != null
                "
                >/</span
              >
              <div class="market-rate-ask">
                <app-number-highlighter
                  [startAfterDecimal]="true"
                  [value]="marketRates.spotRates.ask"
                  [indicesToHighlight]="pipsHighlightedIndices"
                ></app-number-highlighter>
              </div>
            </span>
          }
        </div>

        <div class="rfq-setup-content__row rfq-setup-content__row--market-rate">
          @if (marketDataSwapPoint) {
            <span class="market-rate-container">
              <div class="market-rate-bid">
                <app-number-highlighter
                  [startAfterDecimal]="true"
                  [value]="marketDataSwapPoint.bid"
                  [indicesToHighlight]="pipsHighlightedIndices"
                ></app-number-highlighter>
              </div>

              <span
                *ngIf="
                  marketDataSwapPoint.bid != null &&
                  marketDataSwapPoint.ask != null
                "
                >/</span
              >
              <div class="market-rate-ask">
                <app-number-highlighter
                  [startAfterDecimal]="true"
                  [value]="marketDataSwapPoint.ask"
                  [indicesToHighlight]="pipsHighlightedIndices"
                ></app-number-highlighter>
              </div>
            </span>
          }
        </div>

        <div class="rfq-setup-content__row rfq-setup-content__row--market-rate">
          @if (marketRates) {
            <ng-container *ngTemplateOutlet="marketForwardRates" />
          }
        </div>
      }
    </ng-container>
  </form>
</div>

<ng-template #marketForwardRates>
  @if (marketDataFwdRate) {
    <span class="market-rate-container">
      <div class="market-rate-bid">
        <app-number-highlighter
          [startAfterDecimal]="true"
          [value]="marketDataFwdRate.bid"
          [indicesToHighlight]="pipsHighlightedIndices"
        ></app-number-highlighter>
      </div>

      <span
        *ngIf="marketDataFwdRate.bid != null && marketDataFwdRate.ask != null"
        >/</span
      >
      <div class="market-rate-ask">
        <app-number-highlighter
          [startAfterDecimal]="true"
          [value]="marketDataFwdRate.ask"
          [indicesToHighlight]="pipsHighlightedIndices"
        ></app-number-highlighter>
      </div>
    </span>
  }
</ng-template>

<ng-template #fwdRatesFromHedgeQuote>
  @if (
    form.controls['fwdRateAsk']?.enabled && form.controls['fwdRateBid']?.enabled
  ) {
    <ng-container *ngTemplateOutlet="marketForwardRates" />
  } @else if (form.controls['fwdRateMid']?.enabled) {
    <span class="market-rate-container market-rate-container--mid">
      <div class="market-rate-mid">
        <app-number-highlighter
          [startAfterDecimal]="true"
          [value]="marketRates.forwardRates[index].mid"
          [indicesToHighlight]="pipsHighlightedIndices"
        ></app-number-highlighter>
      </div>
    </span>
  }
</ng-template>
